import React from 'react';
import { cn } from '../../utils/cn';

export interface DataToolbarProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  controlsLayoutClassName?: string;
  controlsClassName?: string;
  actionsClassName?: string;
}

export function DataToolbar({
  children,
  actions,
  className,
  controlsLayoutClassName = 'grid flex-1 gap-3 sm:grid-cols-2 lg:grid-cols-4',
  controlsClassName,
  actionsClassName,
}: DataToolbarProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between',
        className,
      )}
    >
      <div className={cn(controlsLayoutClassName, controlsClassName)}>{children}</div>
      {actions ? (
        <div className={cn('flex flex-wrap items-center gap-2', actionsClassName)}>{actions}</div>
      ) : null}
    </div>
  );
}
